import { render, staticRenderFns } from "./PriceTracking.vue?vue&type=template&id=46db686b&scoped=true&"
import script from "./PriceTracking.vue?vue&type=script&lang=js&"
export * from "./PriceTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46db686b",
  null
  
)

export default component.exports